<template>
    <div class="product-list">
     <!--搜索表单-->
     <div class="common-seach-wrap">
       <el-tabs v-model="activeName" @tab-click="handleClick">
         <el-tab-pane label="近7天数据" name="type7"></el-tab-pane>
         <el-tab-pane label="近30天数据" name="type30"></el-tab-pane>
         <el-tab-pane label="全部" name="typeall"></el-tab-pane>
       </el-tabs>
       <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
         
 
         <el-form-item label="司机名称/手机号"><el-input size="small" v-model="searchForm.user_key" placeholder="司机名称/手机号搜索"></el-input></el-form-item>
         <el-form-item>
           <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
         </el-form-item>
       </el-form>
     </div>
 
 
     <!--内容-->
     <div class="product-content">
       <div class="table-wrap">
         <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"   >
          <el-table-column prop="nickName" label="司机名称"></el-table-column>
          <el-table-column prop="mobile" label="联系方式"></el-table-column>
           <el-table-column prop="performance" label="业绩"></el-table-column>
           
           <el-table-column prop="order_num" label="订单数量"></el-table-column>
           <el-table-column prop="order_in_num" label="进行中"></el-table-column>
           <el-table-column prop="order_finsh_num" label="完单量"></el-table-column>
           <el-table-column prop="order_canel_num" label="已取消"></el-table-column>
           
         </el-table>
       </div>
     </div>
     <!--分页-->
     <div class="pagination">
       <el-pagination
         @size-change="handleSizeChange"
         @current-change="handleCurrentChange"
         background
         :current-page="curPage"
         :page-size="pageSize"
         layout="total, prev, pager, next, jumper"
         :total="totalDataNumber"
       ></el-pagination>
     </div>
 
   </div>
 </template>
 
 <script>
   import StatisticsApi from '@/api/statistics.js';
   export default{
     components:{
     },
     data(){
       return{
         /*是否正在加载*/
         loading: true,
          activeName: 'type7',
         tableData:[],
         /*一页多少条*/
         pageSize: 10,
         /*一共多少条数据*/
         totalDataNumber: 0,
         /*当前是第几页*/
         curPage: 1,
         /*搜索参数*/
         searchForm: {
           user_key: '',
           supply_key: '',
         },
         /*数据对象*/
         dataModel:{}
       }
     },
     provide: function () {
       return {
         dataModel: this.dataModel
       }
     },
     created() {
 
       this.getData();
     },
     methods:{
       /*选择第几页*/
       handleCurrentChange(val) {
         let self = this;
         self.loading = true;
         self.curPage = val;
         self.getData();
       },
 
       /*每页多少条*/
       handleSizeChange(val) {
         this.pageSize = val;
         this.getData();
       },
 
       /*切换菜单*/
       handleClick(tab, event) {
         let self = this;
         self.curPage = 1;
         self.getData();
       },
       /*搜索查询*/
       onSubmit() {
         this.curPage = 1;
         this.getData();
       },
 
       /*获取数据*/
       getData() {
         let self = this;
         let Params = self.searchForm;
         Params.page = self.curPage;
         Params.list_rows = self.pageSize;
         Params.type = self.activeName;
         self.loading = true;
         StatisticsApi.getDriverSales(Params, true)
           .then(res => {
             self.tableData = res.data.list.data;
             self.totalDataNumber = res.data.list.total;
             self.loading = false;
           })
           .catch(error => {});
       }
 
     }
   }
 </script>
 
 <style>
 </style>
 


// WEBPACK FOOTER //
// src/views/statistics/driver/index.vue